import React from 'react';

import { LiveAdminMessage } from '../utils/AdminMessages';

import './AdminMessageBanner.scss';

interface AdminMessageBannerProps {
  message: LiveAdminMessage;
}

/** Messages longer than this get a smaller size so they fit on two lines. */
const LONG_MESSAGE = 70;

/**
 * A message from a Jookable site admin, across the whole screen under the header, for the
 * seconds the admin chose. Navy and gold so it never reads as a coral shout-out, a gold bar
 * along the bottom counting down. It has a row of its own above the video and the video
 * gives up the height: nothing is drawn over the video, which YouTube's API policies forbid.
 */
const AdminMessageBanner = ({ message }: AdminMessageBannerProps) => {
  const total = Math.max(1, message.seconds) * 1000;
  const left = Math.max(0, message.endsAt - Date.now());
  const barStyle = {
    '--admin-message-start': Math.min(1, left / total),
    animationDuration: `${left}ms`,
  } as React.CSSProperties;
  const className = ['admin-message', Array.from(message.message).length > LONG_MESSAGE ? 'is-long' : '']
    .filter(Boolean)
    .join(' ');
  return (
    <section className={className} role="alert" aria-label="Message from Jookable">
      <div className="admin-message-inner">
        <span className="admin-message-badge" aria-hidden="true">
          📢
        </span>
        <div className="admin-message-body">
          <div className="admin-message-label">Message from Jookable</div>
          <div className="admin-message-text">{message.message}</div>
        </div>
      </div>
      <div className="admin-message-bar" style={barStyle} />
    </section>
  );
};

export default AdminMessageBanner;
